import { Row } from '@/components/grid/grid-component';
import { MdOutlineEdit } from 'react-icons/md';
import styled from 'styled-components';

const StyledMainRow = styled(Row)`
  display: flex;
  justify-content: space-between !important;
  margin-bottom: 20px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 32px !important;
  border-radius: 6px;
  width: 100%;
  background-color: ${({ theme }) => theme.COLOR_BLACK} !important;
`;

const MainContainer = styled(Row)`
  margin-bottom: 20px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 32px !important;
`;

const StepDivider = styled.div`
  border-left: 2px solid #ffffff;
  width: 1px;
  height: 44px;
  transform: rotate(0deg);
`;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

const EditIcon = styled(MdOutlineEdit)`
  margin-right: 10px;
  cursor: pointer;
  height: 24px;
  width: 24px;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SupplierSelectDiv = styled.div`
  margin-top: 15px;
  width: 25%;
`;

const styledPricingAll = {
  StyledMainRow,
  StyledDiv,
  Heading,
  EditIcon,
  StepDivider,
  SupplierSelectDiv,
  MainContainer,
};

export default styledPricingAll;
